import "../../index30.css";
import { jsxs as u, jsx as n } from "react/jsx-runtime";
import { a as f } from "../../type-BFTbooL7.js";
import { _ as t } from "../../cs-piwRuCFZ.js";
import x from "../Modal/index.js";
import v from "../../hooks/useBooleanState.js";
const N = "_image_yrvu8_1", y = "_img-element_yrvu8_6", E = "_expandable_yrvu8_14", h = "_caption_yrvu8_18", C = "_expanded-modal_yrvu8_23", b = "_content_yrvu8_24", e = {
  image: N,
  imgElement: y,
  expandable: E,
  caption: h,
  expandedModal: C,
  content: b
};
function w(m) {
  const {
    className: d,
    src: s,
    alt: o = "",
    caption: a,
    imgElementClassName: c,
    captionClassName: r,
    withCaptionHidden: i = !1,
    expandable: l
  } = m, [
    p,
    {
      setTrue: _,
      setFalse: g
    }
  ] = v(!1);
  return s ? /* @__PURE__ */ u(
    "figure",
    {
      className: t(e.image, l && e.expandable, d),
      title: i && typeof a == "string" ? a : void 0,
      children: [
        /* @__PURE__ */ n(
          "img",
          {
            role: "presentation",
            onClick: l ? _ : void 0,
            src: s,
            alt: o,
            className: t(e.imgElement, c)
          }
        ),
        !i && f(a) && /* @__PURE__ */ n("figcaption", { className: t(r, e.caption), children: a }),
        p && /* @__PURE__ */ n(
          x,
          {
            className: e.expandedModal,
            childrenContainerClassName: e.content,
            size: "full",
            heading: a,
            headingLevel: 5,
            onClose: g,
            children: /* @__PURE__ */ n(
              "img",
              {
                className: t(e.imgElement),
                src: s,
                alt: o
              }
            )
          }
        )
      ]
    }
  ) : null;
}
export {
  w as default
};
